/**
 * Strip query string and fragment from a URL so it can be safely logged.
 *
 * Customer URLs are the biggest PII/PHI risk in browser logs — a customer
 * embedding on `https://portal.acme.com/orders/12345?email=user@x.com`
 * would otherwise leak the full querystring into our log pipeline. Query
 * strings and fragments are dropped; scheme + host + pathname are kept so
 * dashboards can still slice by page.
 *
 * Returns the original string when it isn't a parseable URL (e.g. a
 * relative path). Never throws.
 */
export function stripUrlQueryString(url: string): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return url;
  }
}
